import RateContainer from "./RateContainer";

export default RateContainer;
